import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const DivRow = styled.ol`
	display: flex;
	flex-wrap: wrap;
    width: 100%;
    li {
        list-style: none;
    }
`

export default function BreadCrumbs(props) {
    const { breadCrumbTrail } = props;

    return (
        <DivRow itemScope itemType="https://schema.org/BreadcrumbList" style={{ paddingLeft: 15 }}>
			&raquo; 
            <li itemProp="itemListElement" 
                itemScope
                itemType="https://schema.org/ListItem">
                    <Link 
                        itemScope 
                        itemType="https://schema.org/WebPage"
                        itemProp="item" itemID="/categories/"
                        style={{ fontWeight: '600' }} 
                        to="/categories">
                            <span itemProp="name">All Categories</span>
                    </Link>
                    <meta itemProp="position" content="1" />
            </li>
            {(breadCrumbTrail || []).map(({ urlSlug, name }, idx) => (
                <React.Fragment key={urlSlug}>
                    <span style={{ margin: '0 3px' }}>&nbsp;&raquo;</span>
                    <li itemProp="itemListElement" 
                        itemScope
                        itemType="https://schema.org/ListItem" >
                        <Link 
                        itemScope 
                        itemType="https://schema.org/WebPage"
                        itemProp="item" 
                        itemID={`/categories/${urlSlug}/1`} 
                        style={{ fontWeight: '600' }} 
                        to={`/categories/${urlSlug}/1`}> 
                            <span itemProp="name">{name}</span>
                        </Link>
                        <meta itemProp="position" content={idx+2} />
                    </li>
                </React.Fragment>
            ))}
        </DivRow>
    )
}